/* eslint-disable camelcase */
const getFeesInfos = async ({ id, ...params }) => {
  let feeInfo = {};

  try {
    const url = `${process.env.REACT_APP_DOMAIN_URL}/${process.env.REACT_APP_FEE_URL}/${id}?`;
    const result = await fetch(url + new URLSearchParams({ ...params }));
    console.log();
    const {
      name, currency_code: currencyCode,
      totalThisFee: { valueWithoutSR, value: totalValue },
    } = await result.json();
    feeInfo = {
      id,
      name,
      currencyCode,
      totalValue,
      valueWithoutSR,
    };
  } catch (e) {
    // console.error(e);
  }

  return feeInfo;
};

export default getFeesInfos;
